import React from 'react';
import { compose } from '@/utils/story-composer';
import Accordion from '@/components/elements/accordion';

function FooterColumn({ elementProps, title, items }) {
	return (
		<div
			{...elementProps}
			className="col-span-5 md:col-span-1 lg:col-span-1 whitespace-nowrap text-white border-t border-white py-3 leading-6 md:border-0 lg:justify-self-start"
		>
			<Accordion title={title} textColor="text-white">
				<ul className="list-none">{items}</ul>
			</Accordion>
		</div>
	);
}

export default FooterColumn;

compose('footer-column', FooterColumn, { children: ['items'] });
